import { useEffect } from 'react';
export const useOnAfterOpen = _ref => {
  let {
    open,
    onAfterOpen
  } = _ref;
  useEffect(() => {
    if (open && onAfterOpen) onAfterOpen();
  }, [onAfterOpen, open]);
};